import React, { forwardRef } from "react";
import { Card, Container } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const AadeReportTable = forwardRef(function AadeReportTable({ reportData }, ref) {
  const {
    t,
  } = useTranslation();

  const getReportLine = (line, prefix = "") => {
    return (
      <>
        <h5 className="text-center mt-3 font-weight-bold">
          {prefix}
          {line.name}
        </h5>
        <hr />
        <Container className="mt-2">
          <div className="row mb-2">
            <div className="col-6 text-start fw-bold">{t("tables.headers.gross")}</div>
            <div className="col-6 text-end">{line.gross.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("tables.headers.net")}</div>
            <div className="col-6 text-end">{line.net.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.vat")}</div>
            <div className="col-6 text-end">{line.vat.toFixed(2)} €</div>
          </div>
        </Container>
      </>
    );
  };
  return (
    <Card className="regular-table-with-color" ref={ref}>
      <Card.Body className="table-responsive p-0">
        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.vatAnalysis")}</h5>
        <hr />
        <Container className="mt-2">
          {reportData.vats.map((lineData) => getReportLine(lineData))}
          <hr />
        </Container>
        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.classifications")}</h5>
        <hr />
        <Container className="mt-2">
          {reportData.productTypes.map((lineData) => getReportLine(lineData))}
          <hr />
        </Container>
        <h5 className="text-center mt-3 font-weight-bold">{"MODES"}</h5>
        <hr />
        <Container className="mt-2">
          {reportData.modes.map((lineData) => getReportLine(lineData))}
          <hr />
        </Container>
        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.paymentMethods")}</h5>
        <hr />
        <Container className="mt-2">
          {reportData.paymentMethods.map((lineData) => getReportLine(lineData))}
          <hr />
        </Container>
        <h5 className="text-center mt-3 font-weight-bold">{t("tables.headers.totals")}</h5>
        <hr />
        <Container className="mt-2">
          <div className="row mb-2">
            <div className="col-6 text-start fw-bold">{t("tables.headers.gross")}</div>
            <div className="col-6 text-end">{reportData.totals.gross.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("tables.headers.net")}</div>
            <div className="col-6 text-end">{reportData.totals.net.toFixed(2)} €</div>
            <div className="col-6 text-start fw-bold">{t("summaries.vat")}</div>
            <div className="col-6 text-end">{reportData.totals.vat.toFixed(2)} €</div>
          </div>
        </Container>
      </Card.Body>
    </Card>
  );
});

export default AadeReportTable;
